import React from 'react';
import { Hero } from './components/Hero';
import { OpeningLead } from './components/OpeningLead';
import { ProblemSection } from './components/ProblemSection';
import { SolutionReveal } from './components/SolutionReveal';
import { DetailsSection } from './components/DetailsSection';
import { OfferCTA } from './components/OfferCTA';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen w-full bg-linen overflow-x-hidden selection:bg-rose selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <OpeningLead data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <SolutionReveal data-id="element-4" />
      <DetailsSection data-id="element-5" />
      <OfferCTA data-id="element-6" />
      <Footer data-id="element-7" />
    </main>;
}